import { Link, useParams } from 'react-router-dom'
import { useTranslation } from '@/i18n'

export function TeamPage() {
  const { t } = useTranslation()
  const { teamId } = useParams()
  const numericTeamId = parsePositiveInt(teamId)

  if (numericTeamId == null) {
    return (
      <section className="rounded-[1.35rem] border border-red-900/60 bg-red-950/25 p-5 text-red-100">
        <h1 className="text-xl font-black tracking-tight text-white">{t('Team niet gevonden')}</h1>
        <p className="mt-2 text-sm text-red-100/80">{t('De URL bevat geen geldig team-id.')}</p>
      </section>
    )
  }

  return (
    <div className="space-y-5">
      <section className="rounded-[1.35rem] border border-[#111827] bg-[#050607] p-5">
        <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#3f7890]">
          {t('Team')}
        </p>
        <h1 className="mt-3 text-2xl font-black tracking-tight text-white">
          Team #{numericTeamId}
        </h1>
        <p className="mt-2 text-sm text-surface-400">
          {t('Deze teamdetailpagina volgt later in de PWA. De deep link vanuit wedstrijden werkt nu alvast.')}
        </p>
      </section>

      <section className="rounded-[1.35rem] border border-[#202427] bg-[#0a0d0f] p-5">
        <Link
          to="/dashboard/poules"
          className="inline-flex rounded-full border border-[#202427] bg-[#0d1113] px-4 py-2 text-sm font-semibold text-surface-200 transition hover:border-[#24405b] hover:bg-[#151a1c]"
        >
          {t('Terug naar dashboard')}
        </Link>
      </section>
    </div>
  )
}

function parsePositiveInt(value?: string) {
  if (!value) return null
  const parsed = Number(value)
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null
}
